import { Component } from 'shimmer'

import { MeshPhongMaterial, Color, DoubleSide } from 'three'

import { Loader } from '@/utils/Loader'

export class Arms extends Component {
  constructor ({ url }) {
    super({ name: 'bodypart' })

    this.destroy = this.destroy.bind(this)

    this.promise = new Promise(resolve => {
      this.resolve = resolve
    })

    this.promises = []

    this.url = url

    this.colorObject = this.colorObject.bind(this)
    
    this.promises.push(Loader.load(this.url).then(object => {
      this.object = object
      this.add(this.object)
      this.colorObject()
    }))

    Promise.all(this.promises).then(this.resolve)
  }

  colorObject () {
    if (this.object && this._color) {
      this.object.traverse(item => {
        if (item.isMesh) {
          item.material.dispose()
          item.material = new MeshPhongMaterial({
            color: new Color('#' + this._color)
          })
          item.material.side = DoubleSide
        }
      })
    }
    this.opacity = this._opacity
  }

  set color (color) {
    this._color = color
    this.colorObject()
  }

  onDestroy () {
    this.traverse((child) => {
      if (child.isMesh) {
        child.material.dispose()
        child.geometry.dispose()
      }
    })
    this.destroy()
  }
}